import React from "react";
import "../style/Section.css";
import AOS from 'aos';

AOS.init();
const Section = () => {
  return (
    <div data-aos='fade-left' className="section_div">
      <span className="sectionName_span">Game Experience</span>
    </div>
  );
};

export default Section;
